/**
 * AI Context Resolver
 * Determines which AI tools and intro text to show based on where user opens AI from
 */

export const AI_CONTEXTS = {
  HOME: 'home',
  ADD_RECIPE: 'add_recipe',
  RECIPE_DETAIL: 'recipe_detail',
  RECIPES: 'recipes',
  MACHINE_CATALOG: 'machine_catalog',
  MACHINE_SELECTOR: 'machine_selector',
  MATCH: 'match',
  SHOPPING: 'shopping',
  SETTINGS: 'settings',
  DEFAULT: 'default'
};

/**
 * Get AI configuration based on context
 * @param {string} context - The context/page where AI is opened from
 * @returns {object} Configuration with activeTab, availableTabs, and intro text
 */
export const getAIConfig = (context) => {
  switch (context) {
    case AI_CONTEXTS.ADD_RECIPE:
      return {
        activeTab: 'brix',
        availableTabs: ['brix', 'freeze', 'machine', 'cost'],
        intro: 'ai.context.add_recipe',
        title: 'ai.context.add_recipe_title'
      };

    case AI_CONTEXTS.RECIPE_DETAIL:
      return {
        activeTab: 'help',
        availableTabs: ['help', 'create', 'brix', 'freeze'],
        intro: 'ai.context.recipe_detail',
        title: 'ai.context.recipe_detail_title'
      };

    case AI_CONTEXTS.MACHINE_CATALOG:
    case AI_CONTEXTS.MACHINE_SELECTOR:
      return {
        activeTab: 'machine',
        availableTabs: ['machine', 'recommend', 'troubleshoot'],
        intro: 'ai.context.machine',
        title: 'ai.context.machine_title'
      };

    case AI_CONTEXTS.RECIPES:
      return {
        activeTab: 'create',
        availableTabs: ['create', 'brix', 'help'],
        intro: 'ai.context.recipes',
        title: 'ai.context.recipes_title'
      };

    case AI_CONTEXTS.MATCH:
      return {
        activeTab: 'help',
        availableTabs: ['help', 'brix', 'create'],
        intro: 'ai.context.match',
        title: 'ai.context.match_title'
      };

    case AI_CONTEXTS.HOME:
    case AI_CONTEXTS.DEFAULT:
    default:
      return {
        activeTab: 'create',
        availableTabs: ['brix', 'create', 'help', 'machine', 'recommend', 'freeze', 'cost', 'troubleshoot', 'cocktail'],
        intro: 'ai.context.default',
        title: 'ai.context.default_title'
      };
  }
};

/**
 * Map tab IDs to their display order
 */
export const TAB_ORDER = {
  'brix': 1,
  'create': 2,
  'help': 3,
  'machine': 4,
  'recommend': 5,
  'troubleshoot': 6,
  'freeze': 7,
  'cost': 8,
  'cocktail': 9
};

/**
 * Filter and sort tabs based on available tabs
 */
export const filterTabs = (allTabs, availableTabIds) => {
  return allTabs
    .filter(tab => availableTabIds.includes(tab.id))
    .sort((a, b) => (TAB_ORDER[a.id] || 99) - (TAB_ORDER[b.id] || 99));
};
